import { render, staticRenderFns } from "./score_menu.vue?vue&type=template&id=7853d096&scoped=true"
import script from "./score_menu.vue?vue&type=script&lang=js"
export * from "./score_menu.vue?vue&type=script&lang=js"
import style0 from "./score_menu.vue?vue&type=style&index=0&id=7853d096&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7853d096",
  null
  
)

export default component.exports